import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ProductApi} from "../../../common/apis/product-api";
import {Product} from "../../../common/interfaces/Product";
import {Merchant} from "../../../common/interfaces/Merchant";
import {Category} from "../../../common/interfaces/Category";
import {ProductStateEnumMapper} from "../../../common/enums/ProductState";
import {ReadyWithinEnumMapper} from "../../../common/enums/ReadyWithin";
import { Rating, RatingApiResponse } from "../../../common/interfaces/Rating";
import {
  WriteReviewDialogComponent
} from "../merchant/merchant-review-tab/write-review-dialog/write-review-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {BaseApiService} from "../../../common/services/base-api-service";
import { JWTToken } from "../../../common/interfaces/JWTToken";
import { RateAPI } from "../../../common/apis/RateApi";

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit {

  productId: string
  product: Product | null = null
  // merchant: Merchant | null = null
  category: Category | null = null
  recommendedProducts: Product[] = []
  recommendedMerchants: Merchant[] = []
  loading: boolean = false
  productImages: string[] = []
  ratingApiResponse: RatingApiResponse | null = null
  customerLoggedIn: boolean = false
  reviewLabel = $localize`:@@rateDish:Rate this dish`
  numberOfReviews = 0
  averageRating = 0


  jwtToken : JWTToken  | null = null
  isRemoveRateLoading = false

  constructor(
    private route: ActivatedRoute,
    private productApi: ProductApi,
    private router: Router,
    public dialog: MatDialog,
    protected readonly apiClient: BaseApiService,
    protected readonly rateAPI: RateAPI,
  ) {
  }

  ngOnInit(): void {
    // this.productId = this.route.snapshot.params['id'];
    this.route.params.subscribe({
      next: (value) => {
        this.productId = value['id']
        this.loading = true
        this.productImages = []
        this.productApi.getProductById(this.productId, true).subscribe({
          next: (product) => {
            this.loading = false
            this.product = product
            // this.merchantApi.getMerchantById(this.product?.merchantId, false).subscribe({
            //   next: merchant => this.merchant = merchant
            // })
            this.recommendedProducts = product.recommendedProducts ?? []
            this.recommendedMerchants = product.recommendedMerchants ?? []
            // this.getProductCategory(product.categoryId)
            product.images.forEach((image) => {
              this.productImages.push(image.url)
            })
            this.getProductRating()
          },
          error: () => this.loading = false
        })
        this.jwtToken = this.apiClient.getJwt()

        this.customerLoggedIn = (this.jwtToken?.customer !== null && this.jwtToken?.customer !== undefined)
      }
    })
  }

  getProductRating() {
    this.productApi.getProductReviews(this.productId).subscribe({
      next: (apiResponse) => {
        this.ratingApiResponse = apiResponse
        this.numberOfReviews = apiResponse.data.length
      }
    })
  }

  getState(): string {
    if (this.product !== null) {
      return ProductStateEnumMapper.toString(this.product?.state)
    } else {
      return ""
    }
  }

  getReadyWithinState(): string {
    if (this.product !== null) {
      return ReadyWithinEnumMapper.toString(this.product.readyWithin)
    } else {
      return ""
    }
  }

  setDefaultPlaceholder(index: number) {
    this.productImages[index] = "assets/product-placeholder.svg"
  }

  viewMerchant() {
    this.router.navigate(['/page', this.product?.merchant?.slug]).then()
  }

  writeReview() {
    this.dialog.open(WriteReviewDialogComponent, {
      data: {
        id: this.product?.id,
        isProduct: true
      },
      width: '37rem',
      autoFocus: false
    }).afterClosed()
      .subscribe({
        next: (_) => {
          console.log("Calling products Rating after dismiss")
          this.getProductRating()
        }
      });
  }

  getAverageRating() {
    let totalRating = 0
    for (let rating of this.ratingApiResponse!.data) {
      totalRating += rating.rating
    }
    return (totalRating / this.numberOfReviews).toFixed(2)
  }


  showRemoveBtn(rating : Rating):boolean {
    return  rating.commenter.id == this.jwtToken?.customer?.id ?? ""
  }

  onRemoveRate(rate : Rating) {
    this.isRemoveRateLoading = true
    this.rateAPI.deleteRate({ rate: rate }).subscribe({
      next: () => {
        this.getProductRating()
        this.isRemoveRateLoading = true
      },
      error: (error: any) => {
        this.isRemoveRateLoading = false
      },
    });
  }


  getImageAvatar(rate:Rating):string{
    let image =  "assets/customer-icon-placeholder.svg"
    let profilePictureURL = rate.commenter.profilePictureURL ?? ""
    if(profilePictureURL.hasActualValue()){
      image = profilePictureURL
    }
    return image
  }
}
